import { apiClient } from './client';

export const widgetsApi = apiClient.injectEndpoints({
    endpoints: (builder) => ({
        widgets: builder.mutation<void, { book_id: any }>({
            query: ({ book_id }) => ({
                url: '/api/widgets',
                method: 'POST',
                body: { book_id },
            }),
        }),
    }),
});

export const { useWidgetsMutation } = widgetsApi;
